import React from "react";
import PropTypes from "prop-types";
import Image from "./ImageElement";
import "../css/Header.css";
import SQSImg from "../images/SQS.svg";
import SCertImg from "../images/S-Cert.svg";
import SQS_Logo_50001 from "../images/SQS_Logo_50001.svg";
const TIME = 8000;

/**
 * Header component
 * @type {String}
 */
class Header extends React.Component {
  static displayName = "Header";
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    screen: PropTypes.string.isRequired,
    images: PropTypes.array,
    isHome: PropTypes.bool,
  };
  static defaultProps = {
    images: [],
    isHome: false,
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Header";
    this.timer = null;
    this.state = {
      windowWidth: window.innerWidth,
      currentIndex: 0,
    };
    this.nextImage = this.nextImage.bind(this);
  }

  /**
   * @override
   */
  componentDidMount() {
    // FIXME Throttle the event handler, and removeListenner on componentWillUnmount
    window.addEventListener("resize", () =>
      this.setState({ windowWidth: window.innerWidth })
    );

    if (this.props.screen === "desktop" && this.props.images.length > 1) {
      this.timer = setTimeout(() => this.nextImage(), TIME);
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  /**
   * Turn the Slideshow
   */
  nextImage() {
    const oldIndex = this.state.currentIndex;
    const currentIndex =
      (this.state.currentIndex + 1) % this.props.images.length;
    console.log({ oldIndex, currentIndex });
    this.setState({ currentIndex });
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => this.nextImage(), TIME);
  }

  /**
   * Build triangle element
   * @param {Number} wdth window's width
   * @return {Node} Triangle element (svg)
   */
  triangle(wdth) {
    const width = wdth > 700 ? 700 : wdth;
    const height = width * 0.656;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        version="1.1"
        className="svg-triangle"
        role="presentation"
      >
        <polygon
          points={`${width} 0, 0 ${height}, ${width} ${height}`}
          fill="#FDD100"
        />
      </svg>
    );
  }

  /**
   * @override
   */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className || ""} ${
          this.props.isHome ? "isHome" : ""
        }`}
      >
        <div className={`${this.className}__image`}>
          {this.props.images.map((image, index) => (
            <Image
              key={image.ID}
              src={image.desktop_src}
              alt="PQR BETON"
              className={index === this.state.currentIndex ? "current" : ""}
            />
          ))}
        </div>
        {this.props.children && (
          <div>
            <div className={`${this.className}__triangle`}>
              {this.triangle(this.state.windowWidth)}
            </div>
            {this.props.isHome ? (
              this.props.children
            ) : (
              <div
                className={`${this.className}__content`}
                dangerouslySetInnerHTML={{
                  __html: this.props.children,
                }}
              />
            )}
          </div>
        )}
        {this.props.screen === "desktop" && this.props.isHome && (
          <div className={`${this.className}__certifications`}>
            <img src={SQSImg} alt="" />
            <img src={SQS_Logo_50001} alt="" />
            <img src={SCertImg} alt="" />
          </div>
        )}
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js